import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";

const LANGS = [
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "en", label: "English", flag: "🇺🇸" },
];

export default function LanguageSelector({ variant = "topbar" }) {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const current = LANGS.find((l) => l.code === i18n.resolvedLanguage) || LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  const btnCls =
    variant === "topbar"
      ? "flex items-center gap-1.5 hover:text-cream/70 transition-colors"
      : "flex items-center gap-1.5 hover:text-royal transition-colors";

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className={btnCls}
        data-testid="lang-selector-btn"
        aria-label={t("language")}
      >
        <Globe strokeWidth={1.25} className="h-3.5 w-3.5" />
        <span>{current.flag}</span>
        <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
      </button>
      {open && (
        <ul className="absolute right-0 top-full mt-2 z-50 bg-white border border-navy min-w-[180px] shadow-lg text-foreground" data-testid="lang-selector-menu">
          {LANGS.map((l) => {
            const active = l.code === current.code;
            return (
              <li key={l.code}>
                <button
                  onClick={() => change(l.code)}
                  className={`w-full flex items-center justify-between px-4 py-3 text-sm ${active ? "bg-navy text-cream" : "hover:bg-muted"}`}
                  data-testid={`lang-option-${l.code}`}
                >
                  <span className="flex items-center gap-2">
                    <span className="text-base">{l.flag}</span>
                    <span>{l.label}</span>
                  </span>
                  {active && <Check strokeWidth={1.25} className="h-4 w-4" />}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
